/**开始倒计时
 * 参数列表
 * endDate : 结束时间（毫秒）数组，可接受多个；（必须参数）
 * type : 倒计时单位 day , hour , minute ,second ；
 * cutFun(res)：监听倒计时的变化 , res参数就是实时的倒计时值；
 * finished() :倒计时结束的回调
 *
 * 该倒计时函数会返回一个实例，
 * 实例上方法有：1、startCutDown()开始倒计时，默认实例创建后就开始执行。
 *              2、endCutDown()结束倒计时；
 */


export function startCountDate(options) {
    if (!options.endDate) {
        console.error('参数endDate不能为空');
        return false;
    }
    var dt = [],
        now = new Date().getTime(),
        type;
    for (var i = 0; i < options.endDate.length; i++) {
        dt.push(options.endDate[i] - now)
    }
    switch (options.type) {
        case "day":
            type = 86400000;
            break;
        case "hour":
            type = 3600000;
            break;
        case "minute":
            type = 60000;
            break;
        case "second":
            type = 1000;
            break;
        default:
            type = 1000;
            break;
    }

    function CutDown(dt, type) {
        this.dt = dt;
        this.type = type;
    }

    CutDown.prototype = {
        constructor: CutDown,
        startCutDown() {
            _turnFn.call(this, this.dt);

            function _turnFn(dt) {
                var arr = [];
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i] <= 0) {
                        arr.push({
                            day: '0',
                            hour: '00',
                            minute: '00',
                            second: '00'
                        });
                        continue;
                    }
                    var day, hour, minute, second;
                    day = Math.floor(dt[i] / 86400000);
                    this.type <= 3600000 && (hour = Math.floor((dt[i] % 86400000) / 3600000));
                    this.type <= 60000 && (minute = Math.floor((dt[i] % 3600000) / 60000));
                    this.type <= 1000 && (second = Math.floor((dt[i] % 60000) / 1000));
                    arr.push({
                        day: '' + day,
                        hour: hour < 10 ? '0' + hour : '' + hour,
                        minute: minute < 10 ? '0' + minute : '' + minute,
                        second: second < 10 ? '0' + second : '' + second
                    });
                    day = null; //释放内存
                    hour = null;
                    minute = null;
                    second = null;
                }
                this.timout = setTimeout(() => {
                    clearTimeout(this.timout);
                    this.noend = false; //假设即将结束倒计时
                    for (var i = 0; i < dt.length; i++) {
                        if (dt[i] > 0) {
                            dt[i] -= this.type;
                            this.noend = true;
                        } else {
                            dt[i] = 0;
                        }
                    }
                    if (!this.noend) {
                        options.finished && options.finished(); //倒计时结束回调
                        return false; //假设成立，结束倒计时
                    }
                    _turnFn.call(this, dt);
                }, this.type);
                options.cutFun && options.cutFun(arr); //cutFun函数一分一秒的监听倒计时的变化
                arr = null; //释放内存
            }
        },
        endCutDown() {
            clearTimeout(this.timout);
        }
    };
    var cutDown = new CutDown(dt, type);
    cutDown.startCutDown();
    now = null; //释放内存
    dt = null;
    type = null;
    return cutDown;
}